enum EditInviteRequestConstants {
  GET_INVITE_REQUEST_DETAILS = '@EditInviteRequest/GET_INVITE_REQUEST_DETAILS',
  GET_INVITE_REQUEST_DETAILS_REQUEST = '@EditInviteRequest/GET_INVITE_REQUEST_DETAILS_REQUEST',
  GET_INVITE_REQUEST_DETAILS_REQUEST_SUCCESS = '@EditInviteRequest/GET_INVITE_REQUEST_DETAILS_REQUEST_SUCCESS',
  GET_INVITE_REQUEST_DETAILS_REQUEST_ERROR = '@EditInviteRequest/GET_INVITE_REQUEST_DETAILS_REQUEST_ERROR',

  SAVE_INVITE_REQUEST_DETAILS = '@EditInviteRequest/SAVE_INVITE_REQUEST_DETAILS',
  SAVE_INVITE_REQUEST_DETAILS_REQUEST = '@EditInviteRequest/SAVE_INVITE_REQUEST_DETAILS_REQUEST',
  SAVE_INVITE_REQUEST_DETAILS_REQUEST_SUCCESS = '@EditInviteRequest/SAVE_INVITE_REQUEST_DETAILS_REQUEST_SUCCESS',
  SAVE_INVITE_REQUEST_DETAILS_REQUEST_ERROR = '@EditInviteRequest/SAVE_INVITE_REQUEST_DETAILS_REQUEST_ERROR',

  SAVE_AND_APPROVE_INVITE = '@EditInviteRequest/SAVE_AND_APPROVE_INVITE',
  SAVE_AND_APPROVE_INVITE_REQUEST = '@EditInviteRequest/SAVE_AND_APPROVE_INVITE_REQUEST',
  SAVE_AND_APPROVE_INVITE_REQUEST_SUCCESS = '@EditInviteRequest/SAVE_AND_APPROVE_INVITE_REQUEST_SUCCESS',
  SAVE_AND_APPROVE_INVITE_REQUEST_ERROR = '@EditInviteRequest/SAVE_AND_APPROVE_INVITE_REQUEST_ERROR',

  SAVE_AND_REJECT_INVITE = '@EditInviteRequest/SAVE_AND_REJECT_INVITE',
  SAVE_AND_REJECT_INVITE_REQUEST = '@EditInviteRequest/SAVE_AND_REJECT_INVITE_REQUEST',
  SAVE_AND_REJECT_INVITE_REQUEST_SUCCESS = '@EditInviteRequest/SAVE_AND_REJECT_INVITE_REQUEST_SUCCESS',
  SAVE_AND_REJECT_INVITE_REQUEST_ERROR = '@EditInviteRequest/SAVE_AND_REJECT_INVITE_REQUEST_ERROR',
}

export default EditInviteRequestConstants;
